import React, { useState } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import config from '../config/index.json';
import { Link } from 'react-router-dom';

function Footer() {

    const { images } = config;
    const { linkedin, logo, dot } = images;
    const [showFooter, setShowFooter] = useState(false);

    useEffect(() => {
        AOS.init({ duration: 2000 });
        const timer = setTimeout(()=>{
            setShowFooter(true);
        },1000);
    }, []);

    const [activeIndex, setActiveIndex] = useState<number | null>(null);

    const handleClick = (index: number) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    return (
        <div>
            { showFooter &&
            <footer className='bg-blackBlue pt-32 pb-12 px-16 lazy-show-foote'>
                <div className='grid grid-cols-2 gap-12'>
                    <div className='text-white text-3xl font-bold pr-[20%] leading-normal'>
                        Sviluppa con Italy HLG relazioni, alleanze strategiche e partnership nell'industria dell'healthcare
                    </div>
                    <div className='grid grid-cols-2 gap-16 text-white font-semibold leading-normal text-lg'>
                        <div className='border-t border-white/20 py-6'>
                            <span className='text-[#1b8176] mb-2 block'>sede italiana</span>Via Fabio Filzi, 19<br />20124 Milano - Italy<br />p.iva: 12648300155
                        </div>
                        <div className='border-t border-white/20 py-6'>
                            <span className='text-green mb-2 block'>Contatti</span><a href='mailto:info@italyhlg.it'>info@italyhlg.it</a>
                        </div>
                        <div></div>
                        <div className='border-t border-white/20 py-6'>
                            <span className='mb-2 block'>Seguici su</span>
                            <Link
                                to='https://www.linkedin.com/company/italy-hlg'
                                className=''><img src={linkedin} /></Link>
                        </div>
                    </div>
                </div>
                <div className='grid grid-cols-2 gap-12 pt-36'>
                    <div>
                        <img src={logo} className='w-36' />
                    </div>
                    <div className='grid grid-cols-2 gap-16 text-white leading-normal'>
                        <div className='py-6'>
                            © 2023 - Italy HLG
                        </div>
                        <div className='py-6 flex'>
                            <Link
                                to=''
                                className='hover:underline'>Privacy policy</Link>
                            <img src={dot} className='w-1 mx-4' />
                            <Link
                                to=''
                                className='hover:underline'>Cookie policy</Link>
                        </div>
                    </div>
                </div>
            </footer>
        }
        </div>
    )
}

export default Footer